<section
  [ngClass]="{
    'bg-white': bgColor() === 'WHITE',
    'bg-gray-light': bgColor() === 'GRAY',
  }"
  class="relative grid min-h-full grid-cols-1 grid-rows-[auto_1fr]">
  <div class="pointer-events-none sticky top-0 z-10">
    <div class="pointer-events-none flex justify-end p-4">
      <div
        [ngClass]="{ 'bg-white/75': bgColor() === 'WHITE', 'bg-gray-light/75': bgColor() === 'GRAY' }"
        class="pointer-events-auto rounded-full p-3">
        <app-svg (click)="dialogRef.close()" [width]="16" class="cursor-pointer" src="assets/icons/close.svg" />
      </div>
    </div>
  </div>

  <div
    [ngClass]="{
      'bg-white': bgColor() === 'WHITE',
      'bg-gray-light': bgColor() === 'GRAY',
      'p-5': hasPadding(),
    }"
    class="mt-[-50px] desk:mt-[-74px]">
    <ng-content />
  </div>
</section>
